// import React, {
//   createContext,
//   useContext,
//   useEffect,
//   useMemo,
//   useState,
// } from "react";
// import { ReactComponent as ThreeDot } from "../../../../../assets/MainPage/viewBlocks/ThreeDotIon.svg";
// import { ReactComponent as EditIcon } from "../../../../../assets/MainPage/viewBlocks/editIcon.svg";
// import { ReactComponent as Icon } from "../../../../../assets/MainPage/viewBlocks/headingIcon.svg";

// import { ReactComponent as CheckedIcon } from "../../../../../assets/payment/tick-square.svg";
// import { ReactComponent as UnCheckedIcon } from "../../../../../assets/payment/tick-unCheck-square.svg";

// import { Link } from "react-router-dom";

// import { useSortable } from "@dnd-kit/sortable";
// import { CSS } from "@dnd-kit/utilities";

// // redux
// import { useDispatch } from "react-redux";
// import { creatingChangeBLock } from "../../../../../redux/slices/block/changeStatusBlockSlice";
// import {
//   gettingLinkList,
//   resetLinkList,
// } from "../../../../../redux/slices/gettingLinksList/gettingLinkListSlice";

// const HeadingViewBlockCard = ({ item, checkBoxChangeHandler, ids }) => {
//   const dispatch = useDispatch();
//   const SortableItemContext = createContext({
//     attributes: {},
//     listeners: undefined,
//     ref() {},
//   });
//   const {
//     attributes,
//     isDragging,
//     listeners,
//     setNodeRef,
//     setActivatorNodeRef,
//     transform,
//     transition,
//   } = useSortable({
//     id: item._id,
//   });
//   const context = useMemo(
//     () => ({
//       attributes,
//       listeners,
//       ref: setActivatorNodeRef,
//     }),
//     [attributes, listeners, setActivatorNodeRef]
//   );

//   const style = {
//     opacity: isDragging ? 0.4 : undefined,
//     transform: CSS.Translate.toString(transform),
//     transition,
//   };

//   const { ref } = useContext(SortableItemContext);
//   const [WinW, setWinW] = useState(window.innerWidth);
//   useEffect(() => {
//     const handleResize = () => {
//       setWinW(window.innerWidth);
//     };

//     window.addEventListener("resize", handleResize);

//     return () => {
//       window.removeEventListener("resize", handleResize);
//     };
//   }, []);

//   const [URLvalue, setURLvalue] = useState(null);
//   useEffect(() => {
//     setURLvalue(JSON.parse(item?.coloum_value)?.coloum_value);
//   }, [item]);

//   const [state, setState] = useState(null);

//   useEffect(() => {
//     setState(item);
//     setState({
//       ...state,
//       coloum_value: JSON.parse(item?.coloum_value),
//       status: item?.status,
//     });
//      // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [item]);

//   const changeCardStatus = async (e) => {
//     const { checked } = e.target;
//     setState({ ...state, status: checked });
//     // e.prevent.default()
//     const data = {
//       status: checked,
//       optionid: item?._id,
//     };
//     await dispatch(creatingChangeBLock(data)).then(() => {});

//     await fetchingLinkList();
//     // closeBlockSubModal('BioSecSoundCloudModalState')
//   };

//   const fetchingLinkList = async () => {
//     // const linkId = getLinktate?.getBioLink?.response?.[0]?._id;
//     const linkId = localStorage.getItem("linkId");
//     const user = JSON.parse(localStorage.getItem("user"));
//     const userId = user.userid;
//     const usertoken = user.token;
//     const linkListData = {
//       userId,
//       usertoken,
//       linkId,
//     };
//     await dispatch(gettingLinkList(linkListData));
//     dispatch(resetLinkList());
//   };
//   const [checked, setChecked] = useState(false);
//   useEffect(() => {
//     if (ids && item && item._id) {
//       // Add null checks for ids and item
//       if (ids.includes(item._id)) {
//         setChecked(true);
//       } else {
//         setChecked(false);
//       }
//     }
//   }, [ids, item]);
//   return (
//     <SortableItemContext.Provider value={context}>
//       <li
//         ref={setNodeRef}
//         style={style}
//         className="flex items-center gap-[4px] md:gap-2.5"
//       >
//       <div className="hover:bg-slate-200 rounded-full p-1">
//       <ThreeDot
//         {...attributes}
//         {...listeners}
//         ref={ref}
//         className="cursor-grab"
//       />
//       </div>
//       <div className="w-full rounded-lg md:rounded-[10px] shadow-shadow_2 md:shadow-shadow bg-white p-3 md:py-3 md:px-[15px] flex items-center gap-[13px] md:gap-3">
//       <div>
//       <div onClick={() => checkBoxChangeHandler(item?._id)}>
//         {checked ? (
//           <CheckedIcon className="w-[18px] h-[18px] xl:w-[24px] xl:h-[24px] cursor-pointer" />
//         ) : (
//           <UnCheckedIcon className="w-[18px] h-[18px] xl:w-[24px] xl:h-[24px] cursor-pointer" />
//         )}
//       </div>
//     </div>
//       <Link to={`/dashboard/component/editHeader/${item?._id}`}>
//       <div
//         style={{
//           boxShadow: `-2px 3px 7px #754A9144`,
//         }}
//         className={` rounded-lg bg-gradient-to-br from-[#754A91] to-[#54008A] p-[7px]`}
//       >
//         <Icon />
//       </div>
//       </Link>
//       <div className="w-full flex justify-between">
//         <div {...attributes} {...listeners} ref={ref}>
//           <p className="text-small2_b text-body_copy1_color">
//             {" "}
//             {item?.coloum_type}{" "}
//           </p>
//           <p className="text-small3 text-font_light_color">
//             {WinW < 470
//               ? URLvalue?.length > 27
//                 ? URLvalue?.slice(0, 27) + "..."
//                 : URLvalue
//               : WinW < 768
//               ? URLvalue?.length > 45
//                 ? URLvalue?.slice(0, 45) + "..."
//                 : URLvalue
//               : WinW < 990
//               ? URLvalue?.length > 18
//                 ? URLvalue?.slice(0, 18) + "..."
//                 : URLvalue
//               : WinW < 1400
//               ? URLvalue?.length > 39
//                 ? URLvalue?.slice(0, 39) + "..."
//                 : URLvalue
//               : URLvalue?.length > 57
//               ? URLvalue?.slice(0, 57) + "..."
//               : URLvalue}
//           </p>
//         </div>
//         <div className="flex gap-2 md:gap-[15px] items-center">
//         <Link to={`/dashboard/component/editHeader/${item?._id}`}>
//         <EditIcon />
//         </Link>
//           <label className="relative inline-flex items-center cursor-pointer">
//             <input
//               type="checkbox"
//               checked={state?.status}
//               onChange={(e) => changeCardStatus(e)}
//               className="sr-only peer"
//             />
//             <div className="w-[29px] h-[15px] bg-gray-200 rounded-full peer  peer-checked:after:translate-x-[13.5px] peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-[11px] after:w-[11px] after:transition-all peer-checked:bg-green-600"></div>
//           </label>
//         </div>
//       </div>
//       </div>
//       </li>
//     </SortableItemContext.Provider>
//   );
// };

// export default HeadingViewBlockCard;

import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { ReactComponent as ThreeDot } from "../../../../../assets/MainPage/viewBlocks/ThreeDotIon.svg";
import { ReactComponent as EditIcon } from "../../../../../assets/MainPage/viewBlocks/editIcon.svg";
import { ReactComponent as EditIconDark } from "../../../../../assets/MainPage/viewBlocks/editIcon-dark.svg";
import { ReactComponent as Icon } from "../../../../../assets/MainPage/viewBlocks/headingIcon.svg";

import { ReactComponent as CheckedIcon } from "../../../../../assets/payment/tick-square.svg";
import { ReactComponent as UnCheckedIcon } from "../../../../../assets/payment/tick-unCheck-square.svg";

import { Link } from "react-router-dom";

import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

// redux
import { useDispatch, useSelector } from "react-redux";
import { creatingChangeBLock } from "../../../../../redux/slices/block/changeStatusBlockSlice";
import {
  gettingLinkList,
  resetLinkList,
} from "../../../../../redux/slices/gettingLinksList/gettingLinkListSlice";

const HeadingViewBlockCard = ({ item, checkBoxChangeHandler, ids }) => {
  const { darkMode } = useSelector((state) => state.theme);
  const dispatch = useDispatch();
  const SortableItemContext = createContext({
    attributes: {},
    listeners: undefined,
    ref() {},
  });
  const {
    attributes,
    isDragging,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition,
  } = useSortable({
    id: item._id,
  });
  const context = useMemo(
    () => ({
      attributes,
      listeners,
      ref: setActivatorNodeRef,
    }),
    [attributes, listeners, setActivatorNodeRef]
  );

  const style = {
    opacity: isDragging ? 0.4 : undefined,
    transform: CSS.Translate.toString(transform),
    transition,
  };

  const { ref } = useContext(SortableItemContext);
  const [WinW, setWinW] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => {
      setWinW(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const [URLvalue, setURLvalue] = useState(null);
  useEffect(() => {
    setURLvalue(JSON.parse(item?.coloum_value)?.coloum_value);
  }, [item]);

  const [state, setState] = useState(null);

  useEffect(() => {
    setState(item);
    setState({
      ...state,
      coloum_value: JSON.parse(item?.coloum_value),
      status: item?.status,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item]);

  const changeCardStatus = async (e) => {
    const { checked } = e.target;
    setState({ ...state, status: checked });
    // e.prevent.default()
    const data = {
      status: checked,
      optionid: item?._id,
    };
    await dispatch(creatingChangeBLock(data)).then(() => {});

    await fetchingLinkList();
    // closeBlockSubModal('BioSecSoundCloudModalState')
  };

  const fetchingLinkList = async () => {
    // const linkId = getLinktate?.getBioLink?.response?.[0]?._id;
    const linkId = localStorage.getItem("linkId");
    const user = JSON.parse(localStorage.getItem("user"));
    const userId = user.userid;
    const usertoken = user.token;
    const linkListData = {
      userId,
      usertoken,
      linkId,
    };
    await dispatch(gettingLinkList(linkListData));
    dispatch(resetLinkList());
  };
  const [checked, setChecked] = useState(false);
  useEffect(() => {
    if (ids && item && item._id) {
      // Add null checks for ids and item
      if (ids.includes(item._id)) {
        setChecked(true);
      } else {
        setChecked(false);
      }
    }
  }, [ids, item]);

  const shortenedURL =
    WinW < 470
      ? URLvalue?.length > 27
        ? URLvalue?.slice(0, 27) + "..."
        : URLvalue
      : WinW < 768
      ? URLvalue?.length > 45
        ? URLvalue?.slice(0, 45) + "..."
        : URLvalue
      : WinW < 990
      ? URLvalue?.length > 18
        ? URLvalue?.slice(0, 18) + "..."
        : URLvalue
      : WinW < 1400
      ? URLvalue?.length > 39
        ? URLvalue?.slice(0, 39) + "..."
        : URLvalue
      : URLvalue?.length > 57
      ? URLvalue?.slice(0, 57) + "..."
      : URLvalue;

  return (
    <SortableItemContext.Provider value={context}>
      <li
        ref={setNodeRef}
        style={style}
        className="flex items-center gap-[4px] md:gap-2.5"
      >
        <div className="hover:bg-slate-200 rounded-full p-1">
          <ThreeDot
            {...attributes}
            {...listeners}
            ref={ref}
            className="cursor-grab"
          />
        </div>
        <div
          className={`w-full rounded-lg md:rounded-[10px] ${
            darkMode ? "" : "shadow-shadow_2 md:shadow-shadow"
          } bg-white dark:bg-dark-secondary p-3 md:py-3 md:px-[15px] flex items-center gap-[13px] md:gap-3`}
        >
          <div>
            <div onClick={() => checkBoxChangeHandler(item?._id)}>
              {checked ? (
                <CheckedIcon className="w-[18px] h-[18px] xl:w-[24px] xl:h-[24px] cursor-pointer" />
              ) : (
                <UnCheckedIcon className="w-[18px] h-[18px] xl:w-[24px] xl:h-[24px] cursor-pointer" />
              )}
            </div>
          </div>
          <Link to={`/dashboard/component/editTextEditor/${item?._id}`}>
            <div
              style={{
                boxShadow: `-2px 3px 7px #754A9144`,
              }}
              className={` rounded-lg bg-gradient-to-br from-[#754A91] to-[#54008A] p-[7px]`}
            >
              <Icon />
            </div>
          </Link>
          <div className="w-full flex justify-between dark:text-color_v1_dark">
            <div {...attributes} {...listeners} ref={ref}>
              {/* <p className="text-small2_b text-body_copy1_color">
            {" "}
            {item?.coloum_type}{" "}
          </p> */}
              {/* <p className="text-small3 text-font_light_color">
            {WinW < 470
              ? URLvalue?.length > 27
                ? URLvalue?.slice(0, 27) + "..."
                : URLvalue
              : WinW < 768
              ? URLvalue?.length > 45
                ? URLvalue?.slice(0, 45) + "..."
                : URLvalue
              : WinW < 990
              ? URLvalue?.length > 18
                ? URLvalue?.slice(0, 18) + "..."
                : URLvalue
              : WinW < 1400
              ? URLvalue?.length > 39
                ? URLvalue?.slice(0, 39) + "..."
                : URLvalue
              : URLvalue?.length > 57
              ? URLvalue?.slice(0, 57) + "..."
              : URLvalue}

          </p> */}
              <div
                dangerouslySetInnerHTML={{
                  __html: shortenedURL,
                }}
              ></div>
            </div>
            <div className="flex gap-2 md:gap-[15px] items-center">
              <Link to={`/dashboard/component/editTextEditor/${item?._id}`}>
                {darkMode ? <EditIconDark /> : <EditIcon />}
              </Link>
              <label className="relative inline-flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  checked={state?.status}
                  onChange={(e) => changeCardStatus(e)}
                  className="sr-only peer"
                />
                <div className="w-[29px] h-[15px] bg-gray-200 dark:bg-[#404040] rounded-full peer  peer-checked:after:translate-x-[13.5px] peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-[11px] after:w-[11px] after:transition-all peer-checked:bg-green-600 "></div>
              </label>
            </div>
          </div>
        </div>
      </li>
    </SortableItemContext.Provider>
  );
};

export default HeadingViewBlockCard;
